// extracted by mini-css-extract-plugin
module.exports = {"pdfViewer":"pdfViewer__xWdR2","imagePreloader":"imagePreloader__iSJxY","errorBlock":"errorBlock__q5G18"};